module.exports = __webpack_public_path__ + "static/fleet-16-seat-minibus-sm-5ce58afabb18eddcc5e75910e4bbb99e.webp";